import SeoHead from '../components/SeoHead'
import UseCaseIndex from '../views/usecases/UseCaseIndex'
import { useLanguage } from '../i18n/LanguageContext'

const UseCaseIndexPage = () => {
  const { t } = useLanguage()
  const title = t('seo.useCasesTitle')
  const description = t('seo.useCasesDescription')

  return (
    <>
      <SeoHead title={title} description={description} path="/solutions" />
      <UseCaseIndex />
    </>
  )
}

export default UseCaseIndexPage
